var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_9056_47",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1929 5.51559e-07H1.80488C1.51651 -0.000246689 1.23418 0.0826318 0.991708 0.238711C0.749232 0.394791 0.556885 0.617455 0.437702 0.88004C0.318518 1.14262 0.27755 1.434 0.319702 1.71927C0.361855 2.00454 0.485342 2.27161 0.675376 2.4885L8.62838 11.5755C8.86757 11.8492 8.99923 12.2005 8.99887 12.564V19.875C8.99887 19.9914 9.02598 20.1063 9.07805 20.2104C9.13013 20.3145 9.20573 20.4051 9.29887 20.475L13.7989 23.85C13.9103 23.9336 14.0428 23.9845 14.1815 23.997C14.3202 24.0095 14.4597 23.9831 14.5843 23.9208C14.7089 23.8585 14.8136 23.7628 14.8869 23.6443C14.9601 23.5258 14.9989 23.3893 14.9989 23.25V12.564C14.9985 12.2005 15.1302 11.8492 15.3694 11.5755L23.3224 2.487C24.1714 1.518 23.4814 5.51559e-07 22.1929 5.51559e-07Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1929 5.51559e-07H1.80488C1.51651 -0.000246689 1.23418 0.0826318 0.991708 0.238711C0.749232 0.394791 0.556885 0.617455 0.437702 0.88004C0.318518 1.14262 0.27755 1.434 0.319702 1.71927C0.361855 2.00454 0.485342 2.27161 0.675376 2.4885L8.62838 11.5755C8.86757 11.8492 8.99923 12.2005 8.99887 12.564V19.875C8.99887 19.9914 9.02598 20.1063 9.07805 20.2104C9.13013 20.3145 9.20573 20.4051 9.29887 20.475L13.7989 23.85C13.9103 23.9336 14.0428 23.9845 14.1815 23.997C14.3202 24.0095 14.4597 23.9831 14.5843 23.9208C14.7089 23.8585 14.8136 23.7628 14.8869 23.6443C14.9601 23.5258 14.9989 23.3893 14.9989 23.25V12.564C14.9985 12.2005 15.1302 11.8492 15.3694 11.5755L23.3224 2.487C24.1714 1.518 23.4814 5.51559e-07 22.1929 5.51559e-07Z",
    stroke: "#6F9FE9",
    strokeWidth: 4,
    strokeLinecap: "round",
    mask: "url(#path-1-inside-1_9056_47)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c8fa917a.svg";
export { ForwardRef as ReactComponent };